import type { RemarkTag } from '@app/shared/types/sf-data'

import { storeToRefs } from 'pinia'
import { ComputedRef, computed } from 'vue'

import { stringToQuote } from '@app/utils/string-helpers'

import useRemarkTags from './use-remark-tags'
import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

export default function useOpenRemarkModal({
  ledgerId,
  ledgerLabel,
  ownerId,
  ownerType,
  hidePeriodSelector,
  selectedTagIds,
  remarkText,
}: {
  ledgerId?: string | number
  ledgerLabel?: string
  ownerId?: string | number
  ownerType?: string
  hidePeriodSelector?: boolean
  selectedTagIds?: ComputedRef<number[]>
  remarkText?: boolean
}): () => void {
  const workflowReviewItemsStore = useWorfklowReviewItems()
  const { currentReviewItem } = storeToRefs(workflowReviewItemsStore)

  const remarkTags = useRemarkTags() as ComputedRef<RemarkTag[]>

  const effectiveOwnerType = computed(() => {
    return ownerType || currentReviewItem.value?.itemClass
  })

  const effectiveOwnerId = computed(() => {
    return ownerId || currentReviewItem.value?.id
  })

  const openModal = (
    payload: Record<string, unknown> = {},
    callbackPayload: Record<string, unknown> = {}
  ): void => {
    const selectedText = stringToQuote(window.getSelection()?.toString() ?? '')
    const text = remarkText ? payload : null

    const context = {
      ownerType: effectiveOwnerType.value,
      ownerId: effectiveOwnerId.value,
      ledgerId,
      ledgerLabel,
      text: text || selectedText,
      allRemarkTags: remarkTags.value,
      showTags: true,
      hidePeriodSelector: hidePeriodSelector,
      selectedTagIds: selectedTagIds ? selectedTagIds.value : undefined,
      callbackPayload: callbackPayload,
    }

    window.modalCitizen.openModal('new-remark', {
      ...context,
      ...payload,
    })
  }

  return openModal
}
